import { api } from "api/api";
import { AxiosError } from "axios";
import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import Usuario from "model/administracao/cadastro/Usuario";
import DocumentoAcao from "model/documentos/acesso/DocumentoAcao";
import DocumentoAcesso from "model/documentos/acesso/DocumentoAcesso";
import DocumentoPastaAcao from "model/documentos/acesso/DocumentoPastaAcao";
import DocumentoPastaAcesso from "model/documentos/acesso/DocumentoPastaAcesso";

class DocumentoAcessoService {
    
    buscarAcessos(idDocumento: number) {
        return new Promise<DocumentoAcesso>((resolve, reject): void => {
            api
                .get(`/documentoAcesso/${idDocumento}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    salvar(documentoAcesso: DocumentoAcesso) {
        return new Promise<void>((resolve, reject): void => {
            api
                .post(`/documentoAcesso`, documentoAcesso)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    buscarAcoes() {
        return new Promise<DocumentoAcao[]>((resolve, reject): void => {
            api
                .get(`/documentoAcesso/acoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    buscarAcessosPasta(idPasta: number) {
        return new Promise<DocumentoPastaAcesso>((resolve, reject): void => {
            api
                .get(`/documentoAcesso/pasta/${idPasta}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    salvarAcessoPasta(documentoPastaAcesso: DocumentoPastaAcesso) {
        return new Promise<void>((resolve, reject): void => {
            api
                .post(`/documentoAcesso/pasta`, documentoPastaAcesso)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    buscarAcoesPasta() {
        return new Promise<DocumentoPastaAcao[]>((resolve, reject): void => {
            api
                .get(`/documentoAcesso/pasta/acoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    grupos(){
        return new Promise<GrupoUsuarios[]>((resolve, reject): void => {
            api
                .get(`/documentoAcesso/grupos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    usuarios() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/documentoAcesso/usuarios`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default DocumentoAcessoService;